import React, { useEffect } from 'react';
import axios from 'axios';
import { withRouter } from 'react-router-dom';

// Configurar axios para incluir credenciais
axios.defaults.withCredentials = true;

function SocialLoginCallback({ history }) {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const tempToken = urlParams.get('temp_token');

    if (!tempToken) {
      alert('Token temporário inválido.');
      history.push('/');
      return;
    }

    // Configurar a requisição com headers apropriados
     axios.post('https://ws.brandful.com.br/integracoes/processSuccessfulLogin',
    //axios.post('http://localhost:8001/integracoes/processSuccessfulLogin', 
      { temp_token: tempToken },
      {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
        }
      }
    )
    .then(response => {
      const data = response.data;
       
      if (data.status === 1) {
        localStorage.setItem('bfToken', data.token);
        localStorage.setItem('user', JSON.stringify(data.user));
        history.push('/painel/');
      } else {
        alert(data.msg || 'Erro ao finalizar login social.');
        history.push('/');
      }
    })
    .catch(err => {
      console.error('Erro detalhado:', err.response?.data || err.message);
      alert('Falha na comunicação com o servidor.');
      history.push('/');
    });
  }, [history]);

  return <div>Carregando...</div>;
}

export default withRouter(SocialLoginCallback);